exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie_card{position:fixed;bottom:0;right:100px;width:200px;text-align:center;padding:10px;background:#fff;border-width:1px 1px 0;border-style:solid;border-color:grey;cursor:pointer;border-radius:5px 5px 0 0;-webkit-box-shadow:2px 2px 5px 2px grey;box-shadow:2px 2px 5px 2px grey}.cookie_card p{font-size:10pt;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2932a58","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CookiePolicyComponent.vue
// module id = 72
// module chunks = 1